import Layout from '@/components/layout/Layout';
import { FC } from 'react';
import BookCardItem from '@/components/ui/book-card-item/BookCardItem';
import Pagination from '@/components/ui/pagination/Pagination';
import PageSort from '@/components/ui/page-sort/PageSort';
import SectionTitle from '@/components/ui/section-title/SectionTitle';
import Breadcrumbs from '@/components/ui/breadcrumbs/Breadcrumbs';
import { IPodcastPage, IPodcastData } from '@/interfaces/podcastsPage.interface';
import { BOOKS_FOR_PAGE } from '@/helpers/variables';
import { useGetUrlPath } from '@/hooks/useGetUrlPath';

import { getCurrentPageName } from '@/helpers/helpers';

export interface IPodcasts {
  books: IPodcastPage;
  sortingName: string;
  sortingUrl?: string | undefined;
}

const Podcasts: FC<IPodcasts> = ({ books, sortingName, sortingUrl }) => {
  const pagesCount = Math.ceil(books?.total_count / BOOKS_FOR_PAGE);

  //Seo block
  const SEO_TITLE = `Слушать Подкасты онлайн бесплатно и без регистрации или скачать бесплатно в mp3${getCurrentPageName(books.page)}`;
  const SEO_DESCRIPTION = 'Слушать Подкасты онлайн бесплатно и без регистрации или скачать бесплатно в mp3 на Bookz.ru.';
  const SEO_CANONICAL = '/podcasts';

  return (
    <Layout title={SEO_TITLE} description={SEO_DESCRIPTION} canonicalHref={SEO_CANONICAL} pageHref={useGetUrlPath()} robotsNoFollow breadcrumbs={<Breadcrumbs firstPageName="Подкасты" />}>
      <SectionTitle name="Подкасты" />
      <PageSort sortingName={sortingName} url="/podcasts/" />

      <div data-cards="list" className="cardsWrapper">
        {books.data && books.data.length ? (
          books.data.map((book: IPodcastData) => (
            <BookCardItem
              key={book.id}
              book={
                {
                  created_at: book.created_at,
                  genres: book.genres,
                  type: 'podcast',
                  rating: book.rating,
                  voted_users: book.voted_users,
                  book: {
                    title: book.title,
                    description: book.description,
                    external_id: book.external_id,
                    alias: book.alias,
                  },
                  author: {
                    first_name: String(book.authors[0]?.first_name),
                    middle_name: String(book.authors[0]?.middle_name),
                    last_name: String(book.authors[0]?.last_name),
                    alias: String(book.authors[0]?.alias),
                  },
                  authors: book.authors,
                } as any
              }
            />
          ))
        ) : (
          <div>Подкасты не найдены</div>
        )}
      </div>
      {sortingUrl ? <Pagination pagesCount={pagesCount ?? 0} postName={`podcasts/${sortingUrl}/page=`} /> : <Pagination pagesCount={pagesCount ?? 0} postName="podcasts/page=" />}
    </Layout>
  );
};

export default Podcasts;
